import { render, staticRenderFns } from "./mySubmission.vue?vue&type=template&id=574cbb32"
import script from "./mySubmission.vue?vue&type=script&lang=js"
export * from "./mySubmission.vue?vue&type=script&lang=js"
import style0 from "./mySubmission.vue?vue&type=style&index=0&id=574cbb32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports